export default 'beatgig.com'
